import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
export var StyledHead = styled.thead(_templateObject(), function (props) {
  return "\n        font-weight: ".concat(props.theme.components.table.headFontWeight, ";\n        line-height: ").concat(props.theme.components.table.headLineHeight, ";\n        color: ").concat(props.theme.components.table.headColor, ";\n    ");
});